
import Xd from "../../../assets/duotone/Xd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function XdIcon({ className, dataTestid = "XdIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Xd data-testid={dataTestid} className={classes} {...rest} />
  );
}
